export const ACCENT_MARK_CLASS = 'bg-primary text-primary-foreground';
export const SOFT_ACCENT_MARK_CLASS = 'bg-primary/12 text-primary';
